export enum AnalyticsModules {
  Catalog = 'Catalog',
  QuotesCatalog = 'QuotesCatalog',
  OrdersCatalog = 'OrdersCatalog',
  ProductMatch = 'ProductMatch',
  SalesEnablement = 'SalesEnablement',
  AutoRFQList = 'list',
  AutoRFQCreate = 'create',
  AutoRFQEdit = 'edit',
  AutoRFQItem = 'item',
  AutoRFQCatalog = 'catalog',
  AutoRFQProductMatch = 'productMatch'
}

export enum AnalyticsAppType {
  WebApp = 'WebApp',
  Outlook = 'Outlook'
}

export enum SalesEnablementActionType {
  View = 'View',
  ItemClick = 'Item Click',
  ContentClick = 'Content Click',
  MetadataError = 'Metadata Error',
  Error = 'Error'
}
